
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.18 24.348c.18.16.41.24.64.24.29 0 .57-.12.77-.37 1.36-1.61 1.62-3.7.61-4.98-.38-.48-.9-2.02-.37-2.51.4-.37.43-1.01.05-1.41a.996.996 0 00-1.41-.05c-1.63 1.51-.56 4.31.16 5.22.35.44.2 1.53-.57 2.45-.35.42-.3 1.05.12 1.41z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.23 31.498c0 4.67 3.494 8.532 8.006 9.114a.993.993 0 00-.09.626H11c-.55 0-1 .45-1 1s.45 1 1 1h7.405c.081.47.493.83.985.83h15.83c.492 0 .904-.36.986-.83h7.404c.55 0 1-.45 1-1s-.45-1-1-1h-9.166a.99.99 0 00-.09-.626 9.211 9.211 0 007.402-5.833 4.508 4.508 0 003.414 1.56c2.5 0 4.52-2.02 4.52-4.52 0-2.5-2.03-4.53-4.52-4.53-1.06 0-2.038.37-2.81.987v-1.008c0-.51-.42-.93-.93-.93H13.16c-.51 0-.93.42-.93.93v4.23zm22.17-1.44h6.1v-1.86H14.09v1.86h14.09c.51 0 .93.42.93.93s-.42.93-.93.93H14.102c.219 3.846 3.419 6.91 7.318 6.91h11.75c3.9 0 7.1-3.064 7.318-6.91H34.4c-.51 0-.93-.42-.93-.93s.42-.93.93-.93zm8.1 1.76c0-1.47 1.2-2.67 2.67-2.67s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67-2.67-1.2-2.67-2.67z"}}),_c('path',{attrs:{"d":"M30.27 24.938c-.21 0-.41-.06-.59-.19-.45-.33-.54-.95-.22-1.4.31-.43.33-.89.27-.99-.37-.54-1.07-2.37-.04-3.47.38-.4 1.01-.42 1.41-.05.4.37.42.99.06 1.4-.07.19.07.78.21 1 .6.87.47 2.23-.31 3.3-.18.26-.49.4-.79.4z"}})])
          )
        }
      }
    